<template>
  <div class="desk-search-section" ref="deskSearchSection" data-lenis-prevent>
    <div class="content">
      <div class="intro">
        <p class="title-base"></p>
        <div class="close-button" @click="$emit('toggle-desk-search-section')">
          <CloseIcon />
        </div>
      </div>
      <Search :indexes="indexes" ref="searchComponent" />
    </div>
  </div>
</template>

<script setup>
import { gsap } from 'gsap'
import CloseIcon from '@/assets/img/ico/close.svg'

const props = defineProps({
  showDeskSearchSection: Boolean,
})

const deskSearchSection = ref(null)
const searchComponent = ref(null)
const indexes = ['section_vino', 'section_birra']

watch(
  () => props.showDeskSearchSection,
  (newVal) => {
    if (deskSearchSection.value) {
      const sectionHeight = deskSearchSection.value.offsetHeight

      if (newVal) {
        deskSearchSection.value.style.top = `-${sectionHeight}px`
        gsap.to(deskSearchSection.value, {
          y: `${sectionHeight + 30}px`,
          ease: 'power2.inOut',
          duration: 0.7,
          onComplete: () => {
            if (searchComponent.value) {
              searchComponent.value.focusInput()
            }
          },
        })
      } else {
        gsap.to(deskSearchSection.value, {
          y: `-${sectionHeight}px`,
          ease: 'power2.inOut',
          duration: 0.7,
        })
      }
    }
  },
)
</script>

<script>
export default {
  name: 'DeskSearchSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
